import { Button, Link, MenuItem, SplitButton, Tab } from '@getgo/chameleon-web-react-wrapper/register';
import withTracking from './withTracking';

export const TrackedButton = withTracking(Button);
export const TrackedSplitButton = withTracking(SplitButton);
export const TrackedLink = withTracking(Link);
export const TrackedMenuItem = withTracking(MenuItem);
export const TrackedTab = withTracking(Tab);
